<template>
  <nav>
    <ul class="pagination" v-if="totalPages > 1">

      <li class="page-item"
          v-if="!isFirstPage"
          v-bind:class="{ 'disabled' : isFirstPage }"
          >
        <a class="page-link" v-on:click.prevent="prevPage()" tabindex="-1">{{'PREV_PAGE' | translate}}</a>
      </li>

      <li class="page-item" v-if="currentPage != 1">
        <a class="page-link"
           v-on:click.prevent="setPage(1)">
          1
        </a>
      </li>

      <li class="page-item" v-if="currentPage > 2">
        <a class="page-link"
           v-on:click.prevent="prevPage()">
          {{parseInt(currentPage) - 1}}
        </a>
      </li>
      
      <li class="page-item disabled">
        <a class="page-link"
           v-on:click.prevent="">
          {{currentPage}}
        </a>
      </li>

      <li class="page-item" v-if="totalPages - currentPage > 1">
        <a class="page-link"
           v-on:click.prevent="nextPage()">
          {{parseInt(currentPage) + 1}}
        </a>
      </li>

      <li class="page-item" v-if="currentPage != totalPages && totalPages > 0">
        <a class="page-link"
           v-on:click.prevent="setPage(totalPages)">
          {{totalPages}}
        </a>
      </li>
      
      <li class="page-item"
          v-bind:class="{ 'disabled' : isLastPage }"
          v-if="!isLastPage">
        <a class="page-link"
           v-on:click.prevent="nextPage()"
           >{{'NEXT_PAGE' | translate}}</a>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  props: {
    currentPage: {
      default: 1
    },
    pageSize: {
      default: 10
    },
    totalCount: {
      default: 1
    }
  },
  data: function() {
    return {
      dataValue: this.currentPage
    }
  },
  computed: {
    isFirstPage: function() {
      return this.currentPage <= 1;
    },
    isLastPage: function () {
      return this.currentPage >= this.totalPages;
    },
    totalPages: function () {
      return Math.ceil(this.totalCount / this.pageSize);
    }
  },
  methods: {
    prevPage: function() {
      this.dataValue = parseInt(this.dataValue) - 1;
    },
    nextPage: function() {
      this.dataValue = parseInt(this.dataValue) + 1;
    },
    setPage: function(pageNum) {
      this.dataValue = pageNum;
    }
  },
  watch: {
    dataValue: function(val) {
      this.$emit('input', this.dataValue);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/search/PaginationList.vue